"use strict";

exports.__esModule = true;
exports.default = minTranslate;
function minTranslate() {
  return -this.snapGrid[0];
}